import { render, staticRenderFns } from "./KnowledgeCenterFloatingButton.vue?vue&type=template&id=ac4f8a0a&scoped=true&"
import script from "./KnowledgeCenterFloatingButton.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCenterFloatingButton.vue?vue&type=script&lang=js&"
import style0 from "./KnowledgeCenterFloatingButton.vue?vue&type=style&index=0&id=ac4f8a0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac4f8a0a",
  null
  
)

export default component.exports